import React, { Fragment } from "react";
import { useClassList } from "../Hooks/index";
import Loading from "../../../../Common/Components/Loading";
import { useEffect } from "react";
import DataTable from "../../../../Common/Components/DataTable";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import Details from "../Components/Details";
import EditClass from "../Components/EditClass";
function Index() {
  const { loading, getData, data, showModal, setShowModal } = useClassList();
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Fragment>
        <DataTable
          loading={loading.list}
          heads={[
            {
              title: "نام کلاس ",
              key: "name",
            },
            {
              title: "نام مربی ",
              key: "teachers",
              keyName: "proof",
            },
            {
              title: "نحوه برگزاری ",
              key: "type",
              type: "enum",
              enum: {
                online: "مجازی ",
                offline: "حضوری",
                both: "هردو",
              },
            },

            {
              title: "جنسیت",
              key: "gender",

              type: "enum",
              enum: {
                men: " آقایان",
                woman: "بانوان",
                both: "هردو",
              },
            },
          ]}
          list={data && data.data}
          data={data}
          textEmpty="کلاسی برای این برگزار کننده ثبت نشده"
          links={[
            {
              function: selected => {
                setShowModal({
                  ...showModal,
                  status: true,
                  name: "details",
                  modal: selected[0],
                });
              },
              color: "warning text-white",
              size: "col-md-2",
              html: "جزییات",
            },

            {
              function: selected => {
                // history.push({
                //   pathname: "/User/ClassList/SingleClass",
                //   state: {
                //     data: data.data.filter(
                //       item => item.id === selected[0]
                //     )[0],
                //   },
                // });
              },
              color: "info",
              size: "col-md-2",
              html: "ویرایش",
            },
            {
              function: selected => {
                // history.push({
                //   pathname: "/User/AthletesListOfClass",
                //   state: {
                //     class_id: selected[0],
                //   },
                // });
              },
              color: "success",
              size: "col-md-2",
              html: "ورزشکاران",
            },
          ]}
        />

        <CustomModal
          show={showModal.status}
          handleClose={() => {
            setShowModal(false);
          }}
          header={showModal.name == "details" ? "جزییات کلاس" : "ویرایش کلاس"}
        >
          {showModal.name == "details" ? (
            <Details
              data={
                data &&
                data.data &&
                data.data.filter(item => {
                  return item.id == showModal.modal;
                })
              }
            />
          ) : (
            <EditClass
              data={
                data &&
                data.data &&
                data.data.filter(item => {
                  return item.id == showModal.modal;
                })
              }
            />
          )}
        </CustomModal>
      </Fragment>
    </>
  );
}

export default Index;
